import { useTranslation } from 'i18n';
import { Grid, Stack, Typography } from 'ui';

import { guideImages } from '../../data';
import { EvidenceFeedback } from '../EvidenceFeedback/EvidenceFeedback';

export const PartTwo = () => {
  const { t } = useTranslation('features');

  return (
    <Stack
      sx={{
        textAlign: 'start',
        gap: 4,
      }}
    >
      <Typography>{t('helpGuides.aiLoose.partTwo.intro')}</Typography>
      <Grid container>
        <Grid size={6}>
          <EvidenceFeedback
            src={guideImages.goodLooseSpreadVeryWell}
            variant="yes"
            caption={t('helpGuides.aiLoose.partTwo.captions.materialSpreadVeryWell')}
          />
        </Grid>
        <Grid size={6}>
          <EvidenceFeedback
            src={guideImages.goodLooseSpreadWell}
            variant="yes"
            caption={t('helpGuides.aiLoose.partTwo.captions.materialSpreadWell')}
          />
        </Grid>
        <Grid size={6}>
          <EvidenceFeedback
            src={guideImages.goodLooseWithinBlackBox}
            variant="yes"
            caption={t('helpGuides.aiLoose.partTwo.captions.materialInsideBlackBox')}
          />
        </Grid>
        <Grid size={6}>
          <EvidenceFeedback
            src={guideImages.goodLooseFullMaterial}
            variant="yes"
            caption={t('helpGuides.aiLoose.partTwo.captions.squareFullOfMaterial')}
          />
        </Grid>
        <Grid size={6}>
          <EvidenceFeedback
            src={guideImages.goodLoosePurpleLines}
            variant="yes"
            caption={t('helpGuides.aiLoose.partTwo.captions.materialShouldNotTouchPurpleLines')}
          />
        </Grid>
        <Grid size={6}>
          <EvidenceFeedback
            src={guideImages.badLooseCannotSeeMaterial}
            variant="no"
            caption={t('helpGuides.aiLoose.partTwo.captions.cannotSeeAllMaterial')}
          />
        </Grid>
        <Grid size={6}>
          <EvidenceFeedback
            src={guideImages.badLooseHeapedBig}
            variant="no"
            caption={t('helpGuides.aiLoose.partTwo.captions.tooHeapedAndTooBig')}
          />
        </Grid>
        <Grid size={6}>
          <EvidenceFeedback
            src={guideImages.badLooseLargeMarkings}
            variant="no"
            caption={t('helpGuides.aiLoose.partTwo.captions.floorHasLargeMarkings')}
          />
        </Grid>
        <Grid size={6}>
          <EvidenceFeedback
            src={guideImages.badLooseNotGround}
            variant="no"
            caption={t('helpGuides.aiLoose.partTwo.captions.materialNotOnGroundOrTable')}
          />
        </Grid>
        <Grid size={6}>
          <EvidenceFeedback
            src={guideImages.badLooseShadow}
            variant="no"
            caption={t('helpGuides.aiLoose.partTwo.captions.shadow')}
          />
        </Grid>
        <Grid size={6}>
          <EvidenceFeedback
            src={guideImages.badLooseTouchesEdge}
            variant="no"
            caption={t('helpGuides.aiLoose.partTwo.captions.materialTouchesEdge')}
          />
        </Grid>
      </Grid>
    </Stack>
  );
};
